module.exports = __webpack_public_path__ + "./kit/docs/img/code-example-1.c40618640c9b8e65ecc25c9347803df0.svg";